<template>
  <div>
    <div class="wp">
      <ul class="ul-newslist" v-if="newslist.length">
        <li v-for="item of newslist" :key="item.id">
          <a :href="item.linkTo" target="_blank" class="con" v-if="item.linkTo">
            <div class="right">
              <img :src="imageUrl + item.contentImg" />
            </div>
            <div class="left">
              <em v-if="item.commentTime">
                <span class="year">{{ item.commentTime.substring(0, 4) }}</span>
                <span class="date">{{ item.commentTime.substring(5) }}</span>
              </em>
              <em v-else>
                <span class="year">{{ item.createTime.substring(0, 4) }}</span>
                <span class="date">{{ item.createTime.substring(5) }}</span>
              </em>
              <i class="line"></i>
            </div>
            <div class="cen">
              <h3>
                {{ item.contentTitle }}
              </h3>
              <div class="desc">
                {{ item.summary }}
              </div>
            </div>
          </a>
          <div class="con" @click="toDetail(item.id)" v-else>
            <div class="right">
              <img :src="imageUrl + item.contentImg" />
            </div>
            <div class="left">
              <em v-if="item.commentTime">
                <span class="year">{{ item.commentTime.substring(0, 4) }}</span>
                <span class="date">{{ item.commentTime.substring(5) }}</span>
              </em>
              <em v-else>
                <span class="year">{{ item.createTime.substring(0, 4) }}</span>
                <span class="date">{{ item.createTime.substring(5) }}</span>
              </em>
              <i class="line"></i>
            </div>
            <div class="cen">
              <h3>
                {{ item.contentTitle }}
              </h3>
              <div class="desc">
                {{ item.summary }}
              </div>
            </div>
          </div>
        </li>
      </ul>
      <el-empty v-else :description="$t('recruit.desc')"></el-empty>
    </div>
    <div class="pages" v-if="total && total > size">
      <ul>
        <li class="prev" :class="[curPage == 1 ? 'hide' : '']">
          <span @click="prevPage">&lt;</span>
        </li>
        <li
          :class="[curPage == index + 1 ? 'on' : '']"
          v-for="(item, index) of pages"
          :key="index"
        >
          <span @click="navToPage(index + 1)">{{ index + 1 }}</span>
        </li>
        <li class="next" :class="[curPage == pages ? 'hide' : '']">
          <span @click="nextPage">&gt;</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import { Loading } from 'element-ui';
import subnav from '@/components/subnav';
export default {
  components: {
    subnav
  },
  data () {
    return {
      loading: true,
      result: null,
      newRes: {},
      newslist: [],
      pages: '',
      size: '',
      curPage: '',
      total: '',

      pageInfo: {
        zhId: '1436237504629329921',
        enId: '1435845950655832066'
      }
    }
  },

  created () {
    let that = this;
    /* let lang = localStorage.getItem("locale") || 'zh';
    that.lang = lang;
    that.$i18n.locale = lang; */
    Loading.service();
    /* if (that.$i18n.locale === 'zh') {
      that.getNews(that.pageInfo.zhId);
    } else if (that.$i18n.locale === 'en') {
      that.getNews(that.pageInfo.enId);
    } */
    that.getNews(that.pageInfo.enId);
  },
  /* watch: {
    '$i18n.locale' (newValue) {
      Loading.service();
      if (this.$i18n.locale === 'zh') {
        this.getNews(this.pageInfo.zhId);
      } else if (this.$i18n.locale === 'en') {
        this.getNews(this.pageInfo.enId);
      }
    }
  }, */
  methods: {
    // 跳转至详情
    toDetail (id) {
      let that = this
      that.$router.push({ name: 'newsDetails', query: { id: id }, params: { bgimg: that.result.headerImg, type: '1' } })
    },
    // 获取新闻信息
    getNews (id) {
      let that = this;

      let data = {
        id: id
      };

      that.$http
        .getNews(data)
        .then((res) => {
          if (res.code == 200) {
            let result = res.result;
            that.result = result;
            let dataConfigs = JSON.parse(result.dataConfigs).configs[0];
            that.url = dataConfigs.path
            that.categoryId = dataConfigs.params.categoryId
            that.getList();
          }
        })
        .catch((err) => {
          that.$message(
            {
              message: err,
              type: 'error'
            }
          );
        });
    },

    // 获取新闻列表
    getList (page) {
      Loading.service();
      let that = this;
      that.$axios.get(that.url, {
        params: {
          "categoryId": that.categoryId,
          "pageNo": page || 0,
          "column": 'orderNumber',
          "order": 'desc',
          "status": 2,
          "contentDisplay": 1
        }
      }).then(function (res) {
        if (res.status == 200) {
          that.newRes = res.data.result
          that.newslist = res.data.result.records
          Loading.service().close()
          that.pages = res.data.result.pages
          that.curPage = res.data.result.current
          that.total = res.data.result.total
          that.size = res.data.result.size
        }
      }).catch(function (err) {
        that.$message(
          {
            message: err,
            type: 'error'
          }
        );
      });
    },
    // 跳转至某一页
    navToPage (page) {
      let that = this;
      that.curPage = page
      that.getList(page);
    },
    // 上一页
    prevPage () {
      let that = this;
      let prevPage = that.curPage - 1;
      that.curPage = prevPage
      if (prevPage < 1) {
        prevPage = 1
        that.curPage = 1
        return false;
      }
      that.getList(prevPage);
    },
    // 下一页
    nextPage () {
      let that = this;
      let nextPage = that.curPage + 1;
      that.curPage = nextPage
      if (nextPage > that.pages) {
        nextPage = that.pages
        that.curPage = that.pages
        return false;
      }
      that.getList(nextPage);
    },

  },

}
</script>

<style>
</style>